// vendor

// @ts-expect-error nope
window.Ladies = {
    Utility: {},
}

// ts-expect-error nope
window.Widgets = {}

import "@modules/_vendor/js/jquery-2.2.4.min.js"
import "@modules/_vendor/js/jquery.easing.js"
import "@modules/_vendor/js/bootstrap.js"
import "@modules/_vendor/js/_jquery-ui.js"
import "@modules/_vendor/js/tween.js"
import "@modules/_vendor/js/mustache.min.js"
import "@modules/_vendor/css/ionicons.css"
import "@modules/_vendor/css/_jquery-ui.css"

// shared
import "@modules/global/fonts.css"
import "@modules/global/loader.css"
import "@modules/global/lds-grid10.css"
import "@lds/core/themes/default.css"
import "@modules/global/lds-theme.css"
import "@modules/global/page-stripe.css"
// ---- TODO need cleaning/checking start ----
// how can this be added to geolocation only (LocatinoSelector.js)
import "@modules/global/ladies-main"
import "../util/query-parameter"
import "../util/responsive"
import "../util/Seo"
import "../tracking/tracking"
import "../login-user/user"
import "../util/Scrolling"
import "../util/generic-modal"
import "@modules/cookie-modal/cookie-modal"

// TODO not global?
import "../vue-modals/no-affiliates-modal.css"
